import { createContext, useContext } from 'react';

export const MenuContext = createContext<{ handleClose: () => void }>({
  handleClose: () => {
    console.log('');
  },
});
export const useMenuContext = () => {
  return useContext(MenuContext);
};
